import React from "react";
import { HookDosing } from "../../hooks/HookDosing";


export const ManualControlECDialog = ({
    unitId, tankEc, taskEcA, taskEcB, taskEcC, taskPhDownMax, taskPhUpMax
}) => {
    return (
        <div className="ph-dialog" draggable="false">
            <div
                className="ph-level-row"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 19px",
                    alignItems: "center",
                }}
            >
                <div className="ph-value">
                    <p style={{ fontSize: "38px" }}>EC</p>
                    <p>{(Math.round((tankEc) * 100) / 100).toFixed(1)}</p>
                </div>
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент A</p>
                <HookDosing unitId={unitId} used={taskEcA} taskEC='taskEcA'
                    valueTaskEcMin={0} valueTaskEcMax={taskPhDownMax} mode={1} />
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент B</p>
                <HookDosing unitId={unitId} used={taskEcB} taskEC='taskEcB'
                    valueTaskEcMin={0} valueTaskEcMax={taskPhUpMax} mode={1} />
            </div>
            <div className="row-ph-dialog ph-level-row">
                <p>Компонент C</p>
                <HookDosing unitId={unitId} used={taskEcC} taskEC='taskEcC'
                    valueTaskEcMin={0} valueTaskEcMax={taskPhUpMax} mode={1} />
            </div>
        </div>
    )
}
